import {
  Box,
  Container,
  Stack,
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputBase,
  Skeleton,
  Avatar,
} from "@mui/material";
import axios from "axios";
import { url } from "../../utils";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import logoBNB from "../../images/bnb.svg";
import ClosesProjectDetails from "./ClosesProjectDetails";
import { Link } from "react-router-dom";
import Loading from "../../loading";

export default function ClosedProjects() {
  const matches = useMediaQuery("(max-width:750px)");

  const [Data, setData] = useState([]);
  const [findData, setfindData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setloading] = useState(false);
  const initData = async () => {
    setloading(true);
    try {
      const { data } = await axios.get(`${url}/presaleRouter/IODData/`);
      setData(data.iod);
      setloading(false);
    } catch (error) {}
  };
  useEffect(() => {
    initData();
  }, []);
  useEffect(() => {
    setloading(true);
    const init = async () => {
      try {
        let findDataServer = await Data.filter(
          ({ projectStatus }) => projectStatus == "close"
        );

        let newList = [];
        if (search !== "") {
          newList =
            findDataServer &&
            findDataServer.filter((item) => {
              const tokenName = item.tokenName.toLowerCase();
              const tokenSymbol = item.tokenSymbol.toLowerCase();
              const ProjectName = item.projectName.toLowerCase();
              const ProjectStatus = item.projectStatus.toLowerCase();

              const filter = search.toLowerCase();

              return (
                tokenName.includes(filter) ||
                tokenSymbol.includes(filter) ||
                ProjectName.includes(filter) ||
                ProjectStatus.includes(filter)
              );
            });
        }
        let arr =
          newList.length > 0 || search.length > 0 ? newList : findDataServer;
        setfindData(arr);
        setloading(false);
      } catch (error) {}
    };
    setloading(false);

    if (Data.length > 0) {
      init();
    }
  }, [Data, search]);

  return (
    <Box my={matches ? 4 : 10}>
      <Loading loading={loading} />
      <Container maxWidth="lg">
        <Box
          textAlign="center"
          fontSize="30px"
          fontWeight="700"
          fontFamily="Raleway"
        >
          Closed Projects
        </Box>
        <Box width="100%">
          <Stack
            my={3}
            justifyContent="space-between"
            direction="row"
            width="100%"
            borderBottom="1px solid #717988"
          >
            <InputBase
              style={{
                width: "50%",
                fontFamily: "Raleway",
                fontSize: matches ? "12px" : "20px",
              }}
              sx={{ ml: 1, flex: 1 }}
              placeholder="Enter project name or token contract"
              onChange={(e) => setSearch(e.target.value)}
            />
            <IconButton
              type="submit"
              sx={{
                p: "10px",
                width: "5%",
                textAlign: "right",
                color: "#717988",
              }}
              aria-label="search"
            >
              <SearchIcon
                style={{
                  fontSize: matches ? "16px" : "30px",
                }}
              />
            </IconButton>
          </Stack>

          <TableContainer
            style={{
              background: "#271942",
              borderRadius: "10px",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 0px 15px 5px",
              marginBottom: "20px",
            }}
          >
            <Table sx={{ minWidth: 600 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      fontFamily: "Raleway",
                      textAlign: "center",
                      fontStyle: "12px",
                      fontWeight: 300,
                      fontSize: matches ? "12px" : "15px",
                      color: "#ffffff",
                    }}
                  >
                    Project Name
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: "Raleway",
                      textAlign: "center",
                      fontStyle: "12px",
                      fontWeight: 300,
                      fontSize: matches ? "12px" : "15px",
                      color: "#ffffff",
                    }}
                  >
                    Participants
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: "Raleway",
                      textAlign: "center",
                      fontStyle: "12px",
                      fontWeight: 300,
                      fontSize: matches ? "12px" : "15px",
                      color: "#ffffff",
                    }}
                  >
                    Total Raised
                  </TableCell>

                  <TableCell
                    style={{
                      fontFamily: "Raleway",
                      textAlign: "center",
                      fontStyle: "12px",
                      fontWeight: 300,
                      fontSize: matches ? "12px" : "15px",
                      color: "#ffffff",
                    }}
                  >
                    Ended in (UTC)
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: "Raleway",
                      textAlign: "center",
                      fontStyle: "12px",
                      fontWeight: 300,
                      fontSize: matches ? "12px" : "15px",
                      color: "#ffffff",
                    }}
                  >
                    Networks
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {findData.length > 0 ? (
                  findData.map((item, index) => (
                    <TableRow key={index} style={{ height: "73px" }}>
                      <TableCell
                        component="th"
                        style={{
                          width: "24%",
                          fontFamily: "Open Sans",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: matches ? "12px" : "15px",
                          lineHeight: "18px",
                        }}
                        scope="row"
                      >
                        <Link
                          style={{ width: "100%", color: "#05C3DE" }}
                          to={`/closed-projects/${item._id}`}
                        >
                          <Stack
                            fontFamily="Raleway"
                            direction="row"
                            alignItems="left"
                            justifyContent="left"
                            ml={matches ? 1 : 8}
                          >
                            {loading ? (
                              <Skeleton variant="circular">
                                <Avatar />
                              </Skeleton>
                            ) : (
                              <Box mr={2}>
                                {item.logoLink ? (
                                  <img
                                    width={matches ? "40px" : "40px"}
                                    src={item.logoLink}
                                  />
                                ) : (
                                  <Skeleton variant="circular">
                                    <Avatar />
                                  </Skeleton>
                                )}
                              </Box>
                            )}
                            {item.projectName}
                            <br /> {item.tokenSymbol}
                          </Stack>
                        </Link>
                      </TableCell>

                      <ClosesProjectDetails
                        preSaleAddress={item.presaleAddress}
                      />

                      <TableCell
                        style={{
                          fontFamily: "Open Sans",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: matches ? "12px" : "15px",
                          lineHeight: "18px",
                          textAlign: "center",
                        }}
                      >
                        {moment.unix(+item.endTime).format("LL")}
                      </TableCell>

                      <TableCell>
                        <Box display="flex" justifyContent="center">
                          <img width="30px" src={logoBNB} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : loading ? (
                  loading
                ) : (
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        color: "#ffffff",
                        fontSize: matches ? "14px" : "20px",
                        fontFamily: "Raleway",
                      }}
                      colSpan={5}
                    >
                      There is no Closed Project yet
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </Box>
  );
}
